module.exports = __webpack_public_path__ + "img/special.e4222811.png";